import { useEffect, useState } from 'react';
import { getOverview } from '../services/DataService';

/**
 * How many datastores the sandbox runs for the project (vfs-service GET /data, the Data tab's overview): the Data and
 * Traces tabs' Auto reason (utils/projectTabsModel.js tabSignalsOf `stores`). A project made by the scaffolds declares
 * its store only in files (`services/<app>/db/init/*.sql`), not as a service nor a technology, so this is the one
 * signal that sees it. Read once per project and again when `refreshKey` changes (the service list); any failure (an
 * older or sleeping sandbox) is 0.
 */
export default function useDataStoresSignal(projectId, refreshKey = '') {
  const [stores, setStores] = useState(0);
  useEffect(() => {
    if (!projectId) { setStores(0); return undefined; }
    let live = true;
    Promise.resolve().then(() => getOverview(projectId))
      .then((answer) => { if (live) { setStores(Array.isArray(answer?.stores) ? answer.stores.length : 0); } })
      .catch(() => { if (live) { setStores(0); } });
    return () => { live = false; };
  }, [projectId, refreshKey]);
  return stores;
}
